<template>
  <div class="layout">
    <Layout>
      <Sider
        ref="side1"
        hide-trigger
        collapsible
        :collapsed-width="78"
        v-model="isCollapsed"
      >
        <!-- <div style="text-align:center;"><img style="width:150px;" src="../../assets/logo.png" alt=""></div> -->
        <Menu
          @on-select="selectRoute"
          :active-name="activeRouter"
          theme="dark"
          width="auto"
          :class="menuitemClasses"
        >
          <MenuItem
            :name="item.path"
            v-for="(item, index) in navList"
            :key="index"
          >
            <Icon :type="item.icon"></Icon>
            <span>{{ item.name }}</span>
          </MenuItem>
        </Menu>
      </Sider>
      <Layout style="margin-left:200px;margin-top:60px;">
        <Header :style="{ padding: 0 }" class="layout-header-bar ">
          <Icon
            @click.native="collapsedSider"
            :class="rotateIcon"
            :style="{ margin: '0 20px' }"
            type="md-menu"
            size="24"
          ></Icon>
          <span @click="loginOut" style="float:right;margin-right:30px;cursor:pointer">退出登录</span>
        </Header>
        <div
          style="
            width: 100%;
            background-color: #ffffff;
            padding: 30px;
            margin-top: 1px;
          "
        >
          <p style="margin-bottom: 15px; font-size: 15px">
            首页 / {{ activeName }}
          </p>
          <h2 style="margin-bottom: 15px" v-if="activeName == '汇总统计'">
            账单统计
          </h2>
          <h2 style="margin-bottom: 15px" v-else>{{ activeName }}</h2>
          <p v-if="activeName == '汇总统计'">
            本平台仅展示分成金额，实际每月对账打款金额以合同为准)
          </p>
        </div>
        <Content
          :style="{ margin: '20px', background: '#fff', minHeight: '700px' }"
        >
          <router-view />
        </Content>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import { loginOut} from "@/api/api"; //接口测试
export default {
  data() {
    return {
      activeRouter: 0,
      activeName: "",
      isCollapsed: false,
      navList: [
      ],
      promiseList:[]
    };
  },
  computed: {
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  mounted() {
    if(sessionStorage.getItem('menuPermissions')){
        this.promiseList= sessionStorage.getItem('menuPermissions').split(',')
    }
    this.navList=[];
    this.promiseList.forEach(item=>{
      if(item==1){
        this.navList.push({
          name: "汇总统计",
          icon: "md-home",
          route: "index/summary",
          path: "summary",
        })
      }else if(item==2){
          this.navList.push( {
          name: "小说统计",
          icon: "ios-mail-outline",
          route: "index/FictionStatistics",
          path: "FictionStatistics",
        })
      }else if(item==3){
          this.navList.push( {
          name: "分成记录",
          icon: "ios-navigate",
          route: "index/RechargeRecord",
          path: "RechargeRecord",
        })
      }
    })
    console.log( this.promiseList)
    this.activeRouter = this.$route.name;
    if (this.activeRouter == "summary") {
      this.activeName = "汇总统计";
    } else if (this.activeRouter == "FictionStatistics") {
      this.activeName = "小说统计";
    } else if (this.activeRouter == "RechargeRecord") {
      this.activeName = "分成记录";
    }
  },
  methods: {
    selectRoute(name) {
      if (name != this.$route.name) {
        this.$router.push({
          path: "/index/" + name,
        });
        if (name == "summary") {
          this.activeName = "汇总统计";
        } else if (name == "FictionStatistics") {
          this.activeName = "小说统计";
        } else if (name == "RechargeRecord") {
          this.activeName = "分成记录";
        }
      }
    },
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    loginOut() {
      loginOut().then((res) => {
        if (res.code == 200) {
          sessionStorage.removeItem("token");
          this.$router.push({
            path: "/",
          });
        }
        console.log(res);
      });
    },
  },
};
</script>
<style lang="less" scoped>
body {
  height: 100%;
}
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.layout-logo-left {
  width: 90%;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
}
.menu-icon {
  transition: all 0.3s;
}
.rotate-icon {
  transform: rotate(-90deg);
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}
</style>


// WEBPACK FOOTER //
// src/view/index/index.vue